import { FC, useState } from "react";
import { Formik, FormikProps } from "formik";
import { Button, Card } from "@justworkshr/milo-core";
import { Form } from "@justworkshr/milo-form";
import { useGetEoRMemberBackgroundCheckQuery } from "types/generated/operations";
import { BackgroundCheckFormType } from "./types";
import styles from "./BackgroundCheck.module.css";

interface Props {
  memberId: string;
  onSubmit: (values: BackgroundCheckFormType) => void;
}

const LaunchBackgroundCheck: FC<Props> = ({ memberId, onSubmit }) => {
  const [launching, setLaunching] = useState(false);

  const { data: backgroundCheckData } = useGetEoRMemberBackgroundCheckQuery({
    variables: {
      memberId: memberId || "",
    },
    skip: !memberId,
  });

  const candidateFeedbackUrl =
    backgroundCheckData?.backgroundCheckStatus?.candidateFeedbackUrl;

  const handleLaunch = () => {
    setLaunching(true);
    if (candidateFeedbackUrl) {
      window.open(candidateFeedbackUrl, "_blank");
    }
  };

  return (
    <Formik initialValues={{}} onSubmit={onSubmit}>
      {({ handleSubmit }: FormikProps<BackgroundCheckFormType>) => (
        <Form onSubmit={handleSubmit}>
          <Card
            className={styles.card}
            title="Secure background check"
            description="Your employer has requested a background check. Justworks partners with Veremark to securely process this requirement.
            Please have your information ready to complete your background check."
          >
            <div className={styles.buttonGroup}>
              <Button
                color="brand"
                variant="filled"
                onClick={() => {
                  handleLaunch();
                }}
                loading={launching}
                disabled={!candidateFeedbackUrl}
              >
                Launch Veremark
              </Button>
            </div>
          </Card>
        </Form>
      )}
    </Formik>
  );
};

export default LaunchBackgroundCheck;
